import React, { Component } from 'react';
import HotComponent from './_HotComponent';

const styles = {
  wrapperStyle: {
    width: '25%',
    height: '100%',
    float: 'left'
  },
  dataStyle: {
    float: 'left',
    width: '100%',
    height: '230px',
    backgroundColor: 'blue',
    overflow: 'hidden',
    position: 'relative'
  },
}

class HotWrapper extends Component {
  constructor() {
    super()
    this.state = { wrapperSize: { width: '30%', height: '100%' } }
  }
  componentDidMount() {
    const wrapper = this.refs.wrapper;
    this.setState({ width: wrapper.clientWidth + 'px', height: wrapper.clientHeight + 'px' });
  }
  render() {
    const { dataStyle, wrapperStyle } = styles;
    const renderDataStyle = JSON.parse(JSON.stringify(dataStyle));
    // renderDataStyle.width = this.state.wrapperSize.width;
    // renderDataStyle.height = this.state.wrapperSize.height;
    renderDataStyle.height = this.props.window.height - 42 + 'px';

    const renderWrapperStyle = JSON.parse(JSON.stringify(wrapperStyle));
    renderWrapperStyle.width = this.props.width + '%';
    return (
      <div
        className='hotWrapperClass'
        ref='wrapper'
        style={renderWrapperStyle}
      >
        <div style={renderDataStyle}>
          <HotComponent
            active={this.props.active}
            hotState={this.props.hotData}
            tableChange={this.props.onHotChange}
          />
        </div>
      </div>
    )
  }
}

export default HotWrapper



// WEBPACK FOOTER //
// ./src/_HotWrapper.js